import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomTooltipComponent } from './custom-tooltip.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule
  ],
  declarations: [
    CustomTooltipComponent
  ],
  exports:[
    CustomTooltipComponent
  ],
  entryComponents:[
    CustomTooltipComponent
  ]
})
export class CustomTooltipModule { }
